import { render, staticRenderFns } from "./ShiftForm.vue?vue&type=template&id=f4111b0c&scoped=true"
import script from "./ShiftForm.vue?vue&type=script&lang=js"
export * from "./ShiftForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4111b0c",
  null
  
)

export default component.exports